import { render, staticRenderFns } from "./AssessetReviewClass.vue?vue&type=template&id=5cb53358&scoped=true"
import script from "./AssessetReviewClass.vue?vue&type=script&lang=js"
export * from "./AssessetReviewClass.vue?vue&type=script&lang=js"
import style0 from "./AssessetReviewClass.vue?vue&type=style&index=0&id=5cb53358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb53358",
  null
  
)

export default component.exports